Object.defineProperty(exports,"__esModule",{value:true});var _pick2=require("lodash/pick");var _pick3=_interopRequireDefault(_pick2);var _partialRight2=require("lodash/partialRight");var _partialRight3=_interopRequireDefault(_partialRight2);var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};
var _events=require("./events");var _events2=_interopRequireDefault(_events);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}exports.default=

function(WrappedComponent){
return function(_WrappedComponent){_inherits(addEvents,_WrappedComponent);function addEvents(){_classCallCheck(this,addEvents);return _possibleConstructorReturn(this,(addEvents.__proto__||Object.getPrototypeOf(addEvents)).apply(this,arguments));}_createClass(addEvents,[{key:"componentWillMount",value:function componentWillMount()

{
if((0,_isFunction3.default)(_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillMount",this))){
_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillMount",this).call(this);
}
this.state=this.state||{};
var getScopedEvents=_events2.default.getScopedEvents.bind(this);
this.getEvents=(0,_partialRight3.default)(_events2.default.getEvents.bind(this),getScopedEvents);
this.getEventState=_events2.default.getEventState.bind(this);
this.setupEvents(this.props);
}},{key:"componentWillUpdate",value:function componentWillUpdate(

newProps){
if((0,_isFunction3.default)(_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillReceiveProps",this))){
_get(addEvents.prototype.__proto__||Object.getPrototypeOf(addEvents.prototype),"componentWillReceiveProps",this).call(this);
}
this.setupEvents(newProps);
}},{key:"setupEvents",value:function setupEvents(

props){var
sharedEvents=props.sharedEvents;
var components=WrappedComponent.expectedComponents;
this.componentEvents=_events2.default.getComponentEvents(props,components);
this.getSharedEventState=sharedEvents&&(0,_isFunction3.default)(sharedEvents.getEventState)?
sharedEvents.getEventState:function(){return undefined;};
this.baseProps=this.getBaseProps(props);
this.dataKeys=Object.keys(this.baseProps).filter(function(key){return key!=="parent";});
this.hasEvents=props.events||props.sharedEvents||this.componentEvents;
this.events=this.getAllEvents(props);
}},{key:"getBaseProps",value:function getBaseProps(

props){
var sharedParentState=this.getSharedEventState("parent","parent");
var parentState=this.getEventState("parent","parent");
var baseParentProps=(0,_defaults3.default)({},parentState,sharedParentState);
var parentPropsList=baseParentProps.parentControlledProps;
var parentProps=parentPropsList?(0,_pick3.default)(baseParentProps,parentPropsList):{};
var modifiedProps=(0,_defaults3.default)({},parentProps,props);
return(0,_isFunction3.default)(WrappedComponent.getBaseProps)?
WrappedComponent.getBaseProps(modifiedProps):{};
}},{key:"getAllEvents",value:function getAllEvents(

props){
if(Array.isArray(this.componentEvents)){var _componentEvents;
return Array.isArray(props.events)?
(_componentEvents=this.componentEvents).concat.apply(_componentEvents,_toConsumableArray(props.events)):this.componentEvents;
}
return props.events;
}},{key:"getComponentProps",value:function getComponentProps(

component,type,index){var
role=WrappedComponent.role;
var key=this.dataKeys&&this.dataKeys[index]||index;
var baseProps=this.baseProps[key][type]||this.baseProps[key];
if(!baseProps&&!this.hasEvents){
return undefined;
}
if(this.hasEvents){
var baseEvents=this.getEvents(this.props,type,key);
var componentProps=(0,_defaults3.default)(
{index:index,key:role+"-"+type+"-"+key},
this.getEventState(key,type),
this.getSharedEventState(key,type),
component.props,
baseProps);

var events=(0,_defaults3.default)(
{},_events2.default.getPartialEvents(baseEvents,key,componentProps),componentProps.events);

return(0,_assign3.default)(
{},componentProps,{events:events});

}
return(0,_defaults3.default)(
{index:index,key:role+"-"+type+"-"+key},
component.props,
baseProps);

}}]);return addEvents;}(WrappedComponent);

};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/add-events.js
// module id = 1484
// module chunks = 0